import React from 'react';
import ReactMarkdown from 'react-markdown';

interface RichTextDescriptionProps {
  description: string | null;
  className?: string;
}

// Function to process text and preserve single line breaks
function processTextForMarkdown(text: string): string {
  if (!text) return '';
  
  // Split by double line breaks first to preserve existing paragraphs
  const paragraphs = text.split(/\n\s*\n/);
  
  // Process each paragraph to convert single line breaks to hard breaks
  const processedParagraphs = paragraphs.map(paragraph => {
    // Convert single line breaks to "two spaces + line break" which creates hard breaks in Markdown
    // This preserves the line structure without creating too much spacing
    return paragraph
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0) // Remove empty lines
      .join('  \n'); // Two spaces + newline = hard break in Markdown
  });
  
  // Join paragraphs back with double line breaks (paragraph separation)
  return processedParagraphs
    .filter(p => p.length > 0)
    .join('\n\n');
}

export default function RichTextDescription({ description, className = '' }: RichTextDescriptionProps) {
  if (!description) return null;

  // Process the description to handle line breaks properly
  const processedDescription = processTextForMarkdown(description);

  return (
    <div className={`prose prose-sm max-w-none ${className}`}>
      <ReactMarkdown>{processedDescription}</ReactMarkdown>
    </div>
  );
} 